import toMoney from '~/common/masked/toMoney';

const isEmpty = (value: unknown): boolean => value === null || value === undefined || value === '';

export const formatGuarantee = (value: boolean | null | undefined): string => {
  if (value === null || value === undefined) return '-';
  return value ? 'Com Garantia' : 'Sem Garantia';
};

export const formatGuaranteeMoney = (value: number | string | null | undefined): string =>
  isEmpty(value) ? '-' : toMoney(value) || '-';

export const formatGuaranteePercent = (value: number | string | null | undefined): string => {
  if (isEmpty(value)) return '-';
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) return '-';
  return `${(numberValue * 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
};
